import moment from 'moment';

export const addressInputMaxLength = {
    CITY: 30,
    DEPARTMENT: 100,
    EMAIL: 50,
    FIRST_NAME: 30,
    FULL_NAME: 30,
    LAST_NAME: 30,
    PHONE: 15,
    STREET_ADDRESS: 30,
    ZIP_CODE: 10,
};

export const funderInputMaxLength = {
    GRANT_NUMBER: 100,
};

export const paymentInputMaxLength = {
    PO_NUMBER: 16,
};

export const vatTaxInputMaxLength = {
    TAX_EXEMPTION: 20,
    VAT_EXEMPTION: 25,
    VAT_ID: 25,
};

const INFINITY_DATE_STR = '2039-12-31';
const INFINITY_DATE_MS = moment(INFINITY_DATE_STR).valueOf();
export const vatTaxExpirations = {
    IS_NOT_EXPIRE: date => date === INFINITY_DATE_MS || date === INFINITY_DATE_STR,
    NOT_EXPIRE_VALUE: INFINITY_DATE_MS,
};
